import { useNavigate } from 'react-router-dom';
import { getLocalStorage, getWithToken } from '../API/Api';
import { Link } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import { IoSettingsOutline } from 'react-icons/io5';
import { MdOutlineLogout } from 'react-icons/md';
import { toast } from 'react-toastify';
// import THUNDERBOLT_ICON from '../assets/icons/ComniqaiIcon-V3.0/conversations-blueicon.svg';
import THUNDERBOLT_ICON from '../assets/icons/ComniqaiIcon-V3.0/conversations-icon.svg';
import { useContext, useEffect, useState } from 'react';
import { PATHS } from '../routes/paths';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import { useWidgetContext } from '../contexts/WidgetContext';
import SubContext from '../contexts/SubContext';

const Header = () => {
  const Navigate = useNavigate();
  const subsFlag = useContext(SubContext);
  const [isPublishing, setIsPublishing] = useState(false);
  const [apiTokenData, setApiTokenData] = useState(false);
  const FullName = JSON.parse(getLocalStorage('FullName'));
  const user = JSON.parse(getLocalStorage('userDetails'));

  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';

  useEffect(() => {
    const token = getLocalStorage('apiToken');
    if (token) {
      const parsedToken = JSON.parse(token);
      setApiTokenData(parsedToken);
    }
  }, []);

  const publishChatbotData = async (token) => {
    setIsPublishing(true);
    try {
      const response = await getWithToken('publish-data', token);
      if (response.status === 200) {
        toast.success(response?.message);
      } else {
        toast.error(response.message || 'Failed to publish chatbot');
      }
    } catch (error) {
      console.error('Error publishing chatbot:', error);
      toast.error('Something went wrong while publishing');
    } finally {
      setIsPublishing(false);
    }
  };

  const handleClick = () => {
    localStorage.clear();
    Navigate('/login');
  };

  const { hasUnsavedChanges, updateFn } = useWidgetContext();

  const handleSaveClick = (e) => {
    if (hasUnsavedChanges && typeof updateFn === 'function') {
      updateFn(e); // You can pass keyName, value too if needed
    }
  };

  return (
    <>
      {hasUnsavedChanges && (
        <button className='btn-generatedlead outfit-medium d-flex align-items-center gap-2 me-3' onClick={handleSaveClick}>
          <img src={SAVE_ICON} alt='save-icon' /> Save Changes
        </button>
      )}

      <button className='btn-generatedlead outfit-medium d-flex align-items-center gap-2 me-3' disabled={isPublishing} onClick={() => publishChatbotData(apiTokenData)}>
        {isPublishing ? (
          <>
            <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
            Publishing...
          </>
        ) : (
          <>
            <img src={THUNDERBOLT_ICON} alt='thunderbolt-icon' />
            Publish Chatbot
          </>
        )}
      </button>
      <div className='dropdown header-dropdown text-end d-flex align-items-center'>
        <button className='btn header-dropdown-toggle d-flex align-items-center' type='button' id='profileDropdown' data-bs-toggle='dropdown' aria-expanded='false'>
          {user?.profile_image ? (
            <img src={user?.profile_image} alt='profile' className='rounded-circle me-2' />
          ) : (
            <div className='rounded-circle me-2 bg-primary text-white d-flex align-items-center justify-content-center' style={{ width: '32px', height: '32px', fontSize: '14px' }}>
              {FullName.split(' ')
                .map((n) => n[0])
                .join('')}
            </div>
          )}
          <div className='text-start'>
            <p className='outfit-semiBold'>{FullName}</p>
            <small className='outfit-regular'>{subscriptionName} Plan</small>
          </div>
        </button>

        <ul className='dropdown-menu dropdown-menu-end profile-dropdown p-2' aria-labelledby='profileDropdown'>
          <li className='profile-header text-center border-bottom'>
            {user?.profile_image ? (
              <img src={user?.profile_image} alt='avatar' className='rounded-circle mb-2' />
            ) : (
              <div
                className='rounded-circle text-white d-flex align-items-center justify-content-center m-auto mb-2'
                style={{ width: '60px', height: '60px', fontSize: '16px', background: '#dc5385' }}
              >
                {FullName.split(' ')
                  .map((n) => n[0])
                  .join('')}
              </div>
            )}
            <div className='profile-name outfit-bold'>{FullName}</div>
            <div className='profile-email outfit-regular'>{user?.email}</div>
            <span className='badge-pro mt-2 outfit-regular'>{subscriptionName} Plan</span>
          </li>
          <li>
            <Link className='dropdown-item' to={PATHS.USER_PROFILE}>
              <FaUser />
              My Profile
            </Link>
          </li>
          <li>
            <Link className='dropdown-item' to={PATHS.SETTINGS}>
              <IoSettingsOutline />
              Settings
            </Link>
          </li>
          <li>
            <hr className='dropdown-divider m-0' />
          </li>
          <li>
            <button className='dropdown-item text-danger btn btn-link' onClick={handleClick}>
              <MdOutlineLogout className='text-danger' />
              Logout
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
